export const whiteLocaleList = ['au']; //白名单
export const productPageUrl = 'portable-power-station-calculator';
